<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import Icon from 'dashboard/components-next/icon/Icon.vue';

const props = defineProps({
  buttons: {
    type: Array,
    default: () => [],
  },
  callPermissionRequest: {
    type: Boolean,
    default: false,
  },
});

const { t } = useI18n();

const BUTTON_ICONS = {
  URL: 'i-lucide-external-link',
  PHONE_NUMBER: 'i-lucide-phone',
  QUICK_REPLY: 'i-woot-quick-reply',
  COPY_CODE: 'i-lucide-copy',
  CALL_PERMISSION_REQUEST: 'i-lucide-phone',
  SEE_ALL: 'i-lucide-list',
};

// WhatsApp mostra até 3 botões na bolha; com mais, exibe 2 + "Ver todas as opções".
const rows = computed(() => {
  const all = [...props.buttons];
  if (props.callPermissionRequest) {
    all.unshift({
      type: 'CALL_PERMISSION_REQUEST',
      text: t('WHATSAPP_TEMPLATES.PREVIEW.CALL_PERMISSION'),
    });
  }
  if (all.length <= 3) return all;
  return [
    ...all.slice(0, 2),
    { type: 'SEE_ALL', text: t('WHATSAPP_TEMPLATES.PREVIEW.SEE_ALL_OPTIONS') },
  ];
});

const iconFor = button => BUTTON_ICONS[button.type] || 'i-woot-quick-reply';
</script>

<template>
  <div
    v-if="rows.length"
    class="border-t divide-y border-n-strong divide-n-strong"
  >
    <div
      v-for="(button, index) in rows"
      :key="index"
      class="flex gap-1.5 justify-center items-center p-2.5 text-sm font-medium text-n-blue-11"
    >
      <Icon :icon="iconFor(button)" class="size-4 shrink-0" />
      {{ button.text || button.title || 'Button' }}
    </div>
  </div>
</template>
